module.exports = __webpack_public_path__ + "static/redseer-banner-4ec3eb5f05e740915259e86e07d757e6.png";